import React from "react";
import "./BasePointSelector.css";

const BasePointSelector = ({ locations, selectedPoint, onSelectPoint }) => {
  if (!locations || locations.length === 0) {
    return null;
  }

  return (
    <div className="base-point-selector-container">
      <h6 className="fw-bold mb-3">Selecciona punto base:</h6>
      <div className="base-point-cards-wrapper">
        {locations.map((loc, idx) => {
          const isSelected =
            selectedPoint &&
            Number(selectedPoint.latitude) === Number(loc.latitude) &&
            Number(selectedPoint.longitude) === Number(loc.longitude);

          return (
            <div
              key={idx}
              className={`base-point-card ${isSelected ? "selected" : ""}`}
              onClick={() => onSelectPoint(loc)}
            >
              <div className="base-point-card-header">
                <div className="base-point-card-indicator"></div>
                <span className="base-point-card-index">Punto {idx + 1}</span>
              </div>
              <div className="base-point-card-body">
                <div className="base-point-card-address">
                  {loc.direccion || "Sin dirección"}
                </div>
                {loc.referencia && (
                  <div className="base-point-card-reference">
                    <small className="text-muted">Ref: {loc.referencia}</small>
                  </div>
                )}
                <div className="base-point-card-coords">
                  <small>
                    {Number(loc.latitude)}, {Number(loc.longitude)}
                  </small>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BasePointSelector;
